// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable no-plusplus */
import { SubText, TitleH2, TitleH3 } from 'components/Common/Typography'
import { FC, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
// import Clock from 'react-live-clock'
import AOS from 'aos'
import Image from 'next/image'
import Link from 'next/link'
import { AustraliaIcon, Canadacont, ContactInfoIcon1, ContactInfoIcon2, UAEcont, UKcont } from 'components/Common/Icon'
import { WordFill } from 'hooks/WordFill'

const imageContactInfoIcon2 = '/assets/images/contact-info-icon-2.svg'
const imageContactInfoIcon3 = '/assets/images/contact-info-icon-3.svg'
const imageContactInfoIcon4 = '/assets/images/contact-info-icon-4.svg'
const imageContactInfoIcon5 = '/assets/images/contact-info-icon-5.svg'
const imageContactInfoIcon6 = '/assets/images/contact-info-icon-6.svg'
const imageContactInfoIconIndia = '/assets/images/home-page/contact-info-1.svg'

const ContactInformation: FC<{ data }> = ({ data }) => {
  useEffect(() => {
    AOS.init()
  }, [])

  function iconAnimation() {
    const reveals = document.querySelectorAll('.hvr-icon-pop img')
    for (let i = 0; i < reveals.length; i++) {
      const windowHeight = window.innerHeight
      const elementTop = reveals[i].getBoundingClientRect().top
      const elementVisible = 300

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add('hvr-icon-contact')
      } else {
        reveals[i].classList.remove('hvr-icon-contact')
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', iconAnimation)
    return () => window.removeEventListener('scroll', iconAnimation)
  }, [])

  return (
    <section className="contact_information">
      <Container>
        <Row className="justify-content-center align-items-lg-center">
          <Col lg={5}>
            <h3 className="section-title text-black mb-lg-0 mb-sm-3 mb-2">
              <span>Contact</span>{' '}
              <span className="heading-line d-lg-block">Information</span>
            </h3>
          </Col>
          <Col lg={7}>
            <p className="section-desc px-lg-1 text-c-black">
              <WordFill text="Whether you're building next door or across time zones, we stay close in ideas, in execution, and in support." />
            </p>
          </Col>
        </Row>
      </Container>
      <Container className="mt-md-5 mt-2">
        <Row>
          <Col md={4} className="bdr_r p-md-0 border_bottom_mobile">
            <div
              className="inner_block  pb-md-4 pe-md-5 pt-2 border_bottom"
              data-aos="zoom-in"
              data-aos-once="true"
            >
              <div className="d-flex pt-3 flex-column-reverse flex-lg-row">
                <div className="col">
                  <h3 className="title1 mb-2 mb-lg-3">India</h3>
                  {/* <p className="text1">
                     <Clock format="h:mm A" ticking timezone="Asia/Kolkata" /> 
                  </p> */}
                </div>
                <div className="col-auto mb-md-4 mb-lg-0 icon_ftr order-1">
                  {/* <Image
                    data-aos="icon-anim1"
                    data-aos-delay="400"
                    data-aos-once="true"
                    src={imageContactInfoIconIndia}
                    alt="India"
                    width={104}
                    height={121}
                    
export const ContactInfoIcon1: FC<{ className?: string, style?: string }> = ({
  className = '',
  style = '',
}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="105.048"
    height="114.731"
    viewBox="0 0 105.048 114.731"
    className={className}
    style={style}
  >
    <g id="qutb-minar-in-new-delhi-svgrepo-com" transform="translate(-15.4)">
      <g id="Group_77" data-name="Group 77" transform="translate(15.4)">
        <path
          id="Path_570"
          data-name="Path 570"
          d="M168.7,297.974a2.529,2.529,0,0,0-2.526,2.526v9.14a2.526,2.526,0,0,0,5.052,0V300.5A2.529,2.529,0,0,0,168.7,297.974Zm.956,11.666a.956.956,0,0,1-1.911,0V300.5a.956.956,0,0,1,1.911,0Z"
          transform="translate(-118.768 -204.288)"
        />
        <path
          id="Path_571"
          data-name="Path 571"
          d="M195.926,297.974A2.528,2.528,0,0,0,193.4,300.5v9.14a2.526,2.526,0,1,0,5.051,0V300.5A2.529,2.529,0,0,0,195.926,297.974Zm.956,11.666a.955.955,0,0,1-1.911,0V300.5a.955.955,0,1,1,1.911,0Z"
          transform="translate(-137.435 -204.288)"
        />
        <path
          id="Path_572"
          data-name="Path 572"
          d="M284.981,297.974a2.528,2.528,0,0,0-2.526,2.526v9.14a2.526,2.526,0,0,0,5.052,0V300.5A2.528,2.528,0,0,0,284.981,297.974Zm.956,11.666a.955.955,0,0,1-1.911,0V300.5a.955.955,0,1,1,1.911,0Z"
          transform="translate(-198.49 -204.288)"
        />
        <path
          id="Path_573"
          data-name="Path 573"
          d="M312.2,297.974a2.529,2.529,0,0,0-2.526,2.526v9.14a2.526,2.526,0,0,0,5.052,0V300.5A2.528,2.528,0,0,0,312.2,297.974Zm.955,11.666a.955.955,0,0,1-1.911,0V300.5a.955.955,0,1,1,1.911,0Z"
          transform="translate(-217.155 -204.288)"
        />
        <path
          id="Path_574"
          data-name="Path 574"
          d="M164.247,254.045h5.187a.785.785,0,0,0,.786-.785V241.653a.785.785,0,0,0-.786-.785h-5.187a.785.785,0,0,0-.785.785V253.26A.785.785,0,0,0,164.247,254.045Zm.785-11.606h3.616v10.036h-3.616Z"
          transform="translate(-116.91 -165.137)"
        />
        <path
          id="Path_575"
          data-name="Path 575"
          d="M191.472,254.045h5.187a.784.784,0,0,0,.785-.785V241.653a.784.784,0,0,0-.785-.785h-5.187a.785.785,0,0,0-.785.785V253.26A.785.785,0,0,0,191.472,254.045Zm.785-11.606h3.616v10.036h-3.616Z"
          transform="translate(-135.575 -165.137)"
        />
        <path
          id="Path_576"
          data-name="Path 576"
          d="M280.527,254.045h5.187a.785.785,0,0,0,.785-.785V241.653a.785.785,0,0,0-.785-.785h-5.187a.785.785,0,0,0-.785.785V253.26A.785.785,0,0,0,280.527,254.045Zm.785-11.606h3.616v10.036h-3.616Z"
          transform="translate(-196.63 -165.137)"
        />
        <path
          id="Path_577"
          data-name="Path 577"
          d="M307.751,254.045h5.187a.785.785,0,0,0,.785-.785V241.653a.784.784,0,0,0-.785-.785h-5.187a.785.785,0,0,0-.785.785V253.26A.785.785,0,0,0,307.751,254.045Zm.785-11.606h3.616v10.036h-3.616Z"
          transform="translate(-215.295 -165.137)"
        />
        <path
          id="Path_578"
          data-name="Path 578"
          d="M119.663,65.286h-5.857c-.54-10.194-11.537-18.4-25.13-18.706V39.108a.785.785,0,1,0-1.571,0V46.58c-13.593.306-24.59,8.511-25.13,18.706H56.118a.785.785,0,0,0-.785.785v2.612a.785.785,0,0,0,.785.785h1.5v16.71H45.563l-.579-18.4a3.67,3.67,0,0,0-.029-6.605L44.37,46.768a3.671,3.671,0,0,0-.041-6.608l-.568-9.511a3.671,3.671,0,0,0-.049-6.6l-.568-9.511a3.676,3.676,0,0,0-1.636-6.969h-.074A4.224,4.224,0,0,0,38.08,4.212V.785a.785.785,0,1,0-1.571,0V4.211a4.224,4.224,0,0,0-3.355,3.355H33.08a3.676,3.676,0,0,0-1.636,6.969l-.568,9.511a3.671,3.671,0,0,0-.049,6.6l-.568,9.511a3.671,3.671,0,0,0-.041,6.608l-.584,14.405a3.67,3.67,0,0,0-.029,6.605l-.579,18.4H16.185a.785.785,0,0,0-.785.785v26.985a.785.785,0,0,0,.785.785h65.5a.785.785,0,0,0,.785-.785V84.895a5.417,5.417,0,0,1,10.834,0v29.052a.785.785,0,0,0,.785.785h23.286a.785.785,0,0,0,.785-.785V69.467h1.5a.784.784,0,0,0,.785-.785V66.07A.785.785,0,0,0,119.663,65.286ZM87.89,48.141c13.079,0,23.784,7.621,24.345,17.144H63.546C64.106,55.762,74.812,48.141,87.89,48.141ZM37.295,5.706a2.65,2.65,0,0,1,2.527,1.86H34.768A2.65,2.65,0,0,1,37.295,5.706ZM33.08,9.137h8.429a2.108,2.108,0,1,1,0,4.217H33.08a2.108,2.108,0,1,1,0-4.217Zm8.428,5.787h.086l.523,8.757H32.471l.523-8.757h8.515ZM32.463,25.251h9.662a2.108,2.108,0,1,1,0,4.217H32.463a2.108,2.108,0,1,1,0-4.217Zm9.662,5.787h.086l.523,8.757H31.855l.523-8.757h9.748ZM31.846,41.365h10.9a2.108,2.108,0,1,1,0,4.217h-10.9a2.108,2.108,0,1,1,0-4.217ZM31.221,60.8l.553-13.652H42.814L43.367,60.8H31.221Zm.008,1.571h12.13a2.108,2.108,0,1,1,0,4.216H31.23a2.108,2.108,0,1,1,0-4.216Zm-.065,5.786H43.424l.567,18.015H30.6ZM16.971,87.748H57.618v25.414H16.971Zm99.622,25.414H94.879V84.9a6.988,6.988,0,0,0-13.976,0v28.266H59.189V69.467h57.4ZM118.877,67.9H56.9V66.856h61.973V67.9Z"
          transform="translate(-15.4)"
        />
        <path
          id="Path_579"
          data-name="Path 579"
          d="M106.647,297.16a4.158,4.158,0,0,0-4.154,4.154v9.509a.785.785,0,0,0,.785.785h6.737a.785.785,0,0,0,.785-.785v-9.509A4.159,4.159,0,0,0,106.647,297.16Zm2.583,12.878h-5.166v-8.724a2.583,2.583,0,1,1,5.166,0v8.724Z"
          transform="translate(-75.11 -203.73)"
        />
        <path
          id="Path_580"
          data-name="Path 580"
          d="M58.784,318.045H54.831a.785.785,0,0,0-.785.785v6.311a.785.785,0,0,0,.785.785h3.953a.785.785,0,0,0,.785-.785V318.83A.785.785,0,0,0,58.784,318.045ZM58,324.356H55.617v-4.741H58Z"
          transform="translate(-41.895 -218.048)"
        />
      </g>
    </g>
  </svg>
  )
}
                      maxWidth: '88px',
                      minWidth: '56px',
                      width: '4.2vw',
                      height: 'auto',
                    }}
                  /> */}
                  <ContactInfoIcon1 className='ci-icon-1' data-aos="icon-anim1"
                    data-aos-delay="400"
                    data-aos-once="true" />
                </div>
              </div>
              <h3 className="text_para_large mb-0 mb-md-2 fw-600">Ahmedabad</h3>
              <p className="text_para mb-2 mb-md-4">
                1007-1010, Signature-1, <br className="d-none d-md-block" />
                S.G.Highway, Makarba, <br className="d-none d-md-block" />
                Ahmedabad, Gujarat - 380051
              </p>
              <h3 className="text_para_large mb-0 mb-md-2 fw-600">Rajkot</h3>
              <p className="text_para mb-1 mb-md-3">
                1308 - The Spire, 150 Feet Ring Rd,{' '}
                <br className="d-none d-md-block" />
                Manharpura 1, Madhapar, <br className="d-none d-md-block" />{' '}
                Rajkot, Gujarat - 360007
              </p>
            </div>
            <div
              className="inner_block pt-3 pe-md-5 pb-4 pb-md-0"
              data-aos="zoom-in"
              data-aos-once="true"
            >
              <div className="d-flex pt-2 pt-md-3 flex-column-reverse flex-lg-row">
                <div className="col">
                  <h3 className="title1 mb-2 mb-lg-3">UAE</h3>
                  {/* <p className="text1">
                    <Clock format="h:mm A" ticking timezone="Etc/Greenwich" />
                  </p> */}
                </div>
                <div className="col-auto mb-md-4 mb-lg-0 icon_ftr order-1">
                  {/* <Image
                    data-aos="icon-anim1"
                    data-aos-delay="500"
                    data-aos-once="true"
                    src={imageContactInfoIcon6}
                    alt="UAE"
                    width={107}
                    height={107}
                    style={{
                      maxWidth: '100px',
                      minWidth: '50px',
                      width: '4.5vw',
                      height: 'auto',
                    }}
                  /> */}
                  <UAEcont
                    style={{
                      maxWidth: '90px',
                      minWidth: '50px',
                      width: '4.2vw',
                      height: 'auto',
                    }}
                  />
                </div>
              </div>
              <h3 className="text_para_large mb-0 mb-md-2 fw-600">Dubai</h3>
              <p className="text_para mb-1 mb-md-3">
                Dubai Silicon Oasis, DDP, <br className="d-none d-md-block" />
                Building A1, Dubai, UAE
              </p>
            </div>
          </Col>
          <Col md={4} className="bdr_r p-md-0">
            <div
              className="inner_block px-md-3 px-lg-5 px-md-2 bdr_btm pb-md-4 pb-2 pt-md-3 pt-2"
              data-aos="zoom-in"
              data-aos-once="true"
            >
              <div className="d-flex pt-3 flex-column-reverse flex-lg-row">
                <div className="col">
                  <h3 className="title1 mb-2 mb-lg-3">USA</h3>
                  {/* <p className="text1">
                    <Clock
                      format="h:mm A"
                      ticking
                      timezone="America/New_York"
                    />
                  </p> */}
                </div>
                <div className="col-auto mb-md-4 mb-lg-0 icon_ftr order-1">
                  {/* <Image
                    data-aos="icon-anim1"
                    data-aos-delay="300"
                    data-aos-once="true"
                    className=""
                    src={imageContactInfoIcon2}
                    alt="USA"
                    width={115}
                    height={115}
                    style={{
                      maxWidth: '110px',
                      minWidth: '64px',
                      width: '4.5vw',
                      height: 'auto',
                    }}
                  /> */}
                  <ContactInfoIcon2 className='ci-icon-2'  />
                </div>
              </div>
              <h3 className="text_para_large mb-0 mb-md-2 fw-600">Atlanta</h3>
              <p className="text_para mb-2 mb-md-4">
                6851 Roswell Rd 2nd Floor,
                <br className="d-none d-md-block" /> Atlanta, GA, USA 30328
              </p>
              <h3 className="text_para_large mb-0 mb-md-2 fw-600">
                New Jersey
              </h3>
              <p className="text_para mb-2 mb-md-4">
                513 Baldwin Ave, Jersey City,
                <br className="d-none d-md-block" />
                NJ 07306, USA
              </p>

              <h3 className="text_para_large mb-0 mb-md-2 fw-600">
                California
              </h3>
              <p className="text_para pb-md-3 pb-lg-0">
                4701 Patrick Henry Dr. Building{' '}
                <br className="d-none d-md-block" />
                26 Santa Clara, California 95054
              </p>
            </div>
            <div
              className="inner_block px-md-3 px-md-2 px-lg-5 brdr_btm_as pt-md-3 pt-2 pb-md-4 pb-2 pb-md-0"
              data-aos="zoom-in"
              data-aos-once="true"
            >
              <div className="d-flex pt-3 flex-column-reverse flex-lg-row">
                <div className="col">
                  <h3 className="title1 mb-2 mb-lg-3">Australia</h3>
                  {/* <p className="text1">
                     <Clock
                      format="h:mm A"
                      ticking
                      timezone="Australia/Brisbane"
                    /> 
                  </p> */}
                </div>
                <div className="col-auto mb-md-4 mb-lg-0 icon_ftr order-1">
                  {/* <Image
                    data-aos="icon-anim1"
                    data-aos-delay="300"
                    data-aos-once="true"
                    src={imageContactInfoIcon5}
                    alt="Australia"
                    width={106}
                    height={101}
                    style={{
                      maxWidth: '120px',
                      minWidth: '60px',
                      width: '4.5vw',
                      height: 'auto',
                    }}
                  /> */}
                  <AustraliaIcon className='AustraliaIcon-contact' />
                </div>
              </div>
              <h3 className="text_para_large mb-0 mb-md-2 fw-600">
                Queensland
              </h3>
              <p className="text_para">
                120 Highgate Street,
                <br className="d-none d-xl-block" /> Coopers Plains,
                <br className="d-none d-xl-block" /> Brisbane, Queensland 4108
              </p>
            </div>
          </Col>
          <Col md={4} className="p-md-0">
            <div
              className="inner_block ps-md-3 ps-lg-5 bdr_h pt-md-4 pt-2 pb-md-4 pb-2"
              data-aos="zoom-in"
              data-aos-once="true"
            >
              <div className="d-flex pt-2 flex-column-reverse flex-lg-row">
                <div className="col">
                  <h3 className="title1 mb-2 mb-lg-3">UK</h3>
                  {/* <p className="text1">
                    <Clock format="h:mm A" ticking timezone="Etc/Greenwich" />
                  </p> */}
                </div>
                <div className="col mb-md-4 mb-lg-0 icon_ftr order-1">
                  {/* <Image
                    data-aos="icon-anim1"
                    data-aos-delay="500"
                    data-aos-once="true"
                    src={imageContactInfoIcon3}
                    alt="UK"
                    width={107}
                    height={97}
                    style={{
                      maxWidth: '120px',
                      minWidth: '60px',
                      width: '4.8vw',
                      height: 'auto',
                    }}
                  /> */}
                  <UKcont
                    className="mt-xxl-4 ms-xxl-5 mb-2"
                    style={{
                      maxWidth: '90px',
                      minWidth: '50px',
                      width: '4.2vw',
                      height: 'auto',
                    }}
                  />
                </div>
              </div>
              <h3 className="text_para_large mb-0 mb-md-2 fw-600">London</h3>
              <p className="text_para">
                85 Great Portland Street, First{' '}
                <br className="d-none d-md-block" />
                Floor, London, W1W 7LT
              </p>
            </div>

            <div
              className="inner_block ps-md-3 bdr_h pt-md-3 pt-2 ps-lg-5 pb-md-4 pb-2"
              data-aos="zoom-in"
              data-aos-once="true"
            >
              <div className="d-flex pt-2 flex-column-reverse flex-lg-row">
                <div className="col">
                  <h3 className="title1 mb-2 mb-lg-3 pb-xxl-1">Canada</h3>
                  {/* <p className="text1">
                    <Clock format="h:mm A" ticking timezone="America/Cancun" />
                  </p> */}
                </div>
                <div className="col mb-md-3 mb-lg-0 icon_ftr order-1">
                  {/* <Image
                    data-aos="icon-anim1"
                    data-aos-delay="300"
                    data-aos-once="true"
                    src={imageContactInfoIcon4}
                    alt="Canada"
                    width={73}
                    height={73}
                    style={{
                      maxWidth: '90px',
                      minWidth: '50px',
                      width: '4.2vw',
                      height: 'auto',
                    }}
                  /> */}
                  <Canadacont
                    className="mt-xxl-4 ms-xxl-5 mb-2"
                    style={{
                      maxWidth: '90px',
                      minWidth: '50px',
                      width: '4.2vw',
                      height: 'auto',
                    }}
                  />
                </div>
              </div>
              <h3 className="text_para_large mb-0 mb-xl-3 fw-600">
                Burlington
              </h3>
              <p className="text_para mb-xl-4">
                5096 South Service Rd,
                <br className="d-none d-md-block" />
                ON Burlington, L7l 4X4
              </p>
            </div>
            <div
              className="inner_block ps-md-3 pt-3 ps-lg-5"
              data-aos="zoom-in"
              data-aos-once="true"
            >
              <div className="d-lg-flex pt-2 pt-md-3">
                <div className="col contact-us-block">
                  <p className="mb-4 mb-lg-3">
                    Let’s Transform Your Idea into{' '}
                    <br className="d-none d-md-block" /> Reality. Get in Touch
                  </p>
                  <p className="text1 mb-2 mb-lg-3">
                    <Link href="/get-quote/" className="btn">
                      Contact Us
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default ContactInformation
